export const messages = {
  en: {
    addOwnerVoting: {
      title: 'Add Voting',
      voteName: 'Vote Name',
      voteNamePlaceholder: 'Required, please enter vote name',
      type: 'Type',
      typePlaceholder: 'Required, please select type',
      singleChoice: 'Single Choice',
      multipleChoice: 'Multiple Choice',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please select start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please select end time',
      option: 'Option ',
      optionPlaceholder: 'Required, please enter option content',
      addOption: 'Add Option',
      deleteOption: 'Delete Option',
      voteDescription: 'Vote Description',
      voteDescriptionPlaceholder: 'Required, please enter vote description',
      voteRooms: 'Vote Rooms',
      validate: {
        voteName: 'Vote name cannot be empty',
        type: 'Please select type',
        startTime: 'Please select start time',
        endTime: 'Please select end time',
        option: 'Please fill in all options'
      }
    },
    selectRoom: {
      buildingUnit: 'Building Unit',
      roomInfo: 'Room Information',
      unit: 'Unit'
    }
  },
  zh: {
    addOwnerVoting: {
      title: '添加投票',
      voteName: '投票名称',
      voteNamePlaceholder: '必填，请填写投票名称',
      type: '类型',
      typePlaceholder: '必填，请选择类型',
      singleChoice: '单选',
      multipleChoice: '多选',
      startTime: '开始时间',
      startTimePlaceholder: '必填，请选择开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '必填，请选择结束时间',
      option: '选项',
      optionPlaceholder: '必填，请填写选项内容',
      addOption: '增加选项',
      deleteOption: '删除选项',
      voteDescription: '投票说明',
      voteDescriptionPlaceholder: '必填，请输入投票说明',
      voteRooms: '投票房屋',
      validate: {
        voteName: '名称不能为空',
        type: '请选择类型',
        startTime: '请选择开始时间',
        endTime: '请选择结束时间',
        option: '请填写所有选项内容'
      }
    },
    selectRoom: {
      buildingUnit: '楼栋单元',
      roomInfo: '房屋信息',
      unit: '单元'
    }
  }
}